import script from "./StaffScheduleBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffScheduleBlock.vue?vue&type=script&setup=true&lang=js"

import "./StaffScheduleBlock.vue?vue&type=style&index=0&id=37149baa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37149baa"]])

export default __exports__